
import {Type} from "class-transformer";
import {VoucherRegister} from "@app/shared/classes/voucher-register";
import {PaymentStatusType} from "@app/shared/enums/payment-status-type.enum";
import {FundingSourceStatus, FundingSourceType, PaymentType} from "@app/shared/enums/payment-type.enum";
import {PaymentTxnType, Transaction} from "@app/shared/enums/txn-type.enum";
import {AchDefaultPaymentType} from "@app/shared/classes/org-ach-detail";
import {serializeType} from '@app/shared/classes/common';

export class OrgPaymentTransaction {
  id?: number;
  version?: number;
  transactionId?: string;
  paymentType: PaymentType;
  paymentStatus: PaymentStatusType;
  errorMessage?: string;
  txnType: PaymentTxnType;
  paymentAmount: number;
  txnTotalAmount: number;
  checkOrReferenceNumber?: string;
  paymentFileId?: number;
  voucherRegisterId: number;
  senderPaymentId?: number;
  receiverPaymentId?: number;
  senderPaymentMethodId?: string;
  receiverPaymentMethodId?: string;
  senderBankName: string;
  senderAccountNumber: string;
  senderRoutingNumber: string;
  receiverBankName: string;
  receiverAccountNumber: string;
  receiverRoutingNumber: string;
  canCancelTransaction?: boolean;

}

export class PaymentTransactionSummary {
  orgId?: number;
  transactionId?: string;
  recipientName?: string;
  totalAmount?: number;
  status?: PaymentStatusType;
  paymentType?: PaymentType;
  txnType?: Transaction;
}

export class PaymentRequest {
  senderPaymentId?: number;
  receiverPaymentId?: number;
  senderPaymentMethodId?: string;
  receiverPaymentMethodId?: string;
  checkOrReferenceNumber?: string;
  orgAchIdForCheck: number;
  paymentType: PaymentType;

}

export class MultipleVoucherRegisterPayment {
  paymentRequest: PaymentRequest;
  @Type(serializeType(VoucherRegister)) voucherRegisterSet: VoucherRegister[];
}

export class AchError {
  code?: string;
  message?: string;
}

export class AchAmount {
  value?: string;
  currency?: string;
}


//TODO: Remove if conflicting with  Funding Source being developed by Nivas
export class AchFundingSource {
  id?: number;
  version?: number;
  fundingSourceId?: string;
  fundingSourceType?: FundingSourceType;
  status?: FundingSourceStatus;
  customerId?: number;
  // Transient Fields
  bankName?: string;
  routingNumber?: string;
  accountNumber?: string;
  fundingSourceName?: string;
  customerDwollaId?: string;
  achDefaultPaymentType?: AchDefaultPaymentType;
  vendorActivePayAccount?: boolean;

}

export class RoutingNumberInfo {
  routingNumber: string;
  valid: boolean;
}
